import { IkasOrderLineVariantUnitType } from "./unit-type";

export type IkasOrderLineBaseUnit = {
  baseAmount: number;
  type: IkasProductUnitType;
  unit: IkasOrderLineVariantUnitType | null;
};

export enum IkasProductUnitType {
  CENTILITER = "CENTILITER",
  CENTIMETER = "CENTIMETER",
  CUBIC_METERS = "CUBIC_METERS",
  CUSTOM = "CUSTOM",
  GRAM = "GRAM",
  KILOGRAM = "KILOGRAM",
  LITER = "LITER",
  METER = "METER",
  MILLIGRAM = "MILLIGRAM",
  MILLILITER = "MILLILITER",
  MILLIMETER = "MILLIMETER",
  SQUARE_METERS = "SQUARE_METERS",
}
